import type { IconProps } from '../types/IconProps.ts';
export const SquareArrowUpLeft: IconProps = {
    name: 'SquareArrowUpLeft',
    children: [
        `<path d="m10 10 5 5M20.5 21h-17a.5.5 0 0 1-.5-.5v-17c0-.28.22-.5.5-.5h17c.28 0 .5.22.5.5v17a.5.5 0 0 1-.5.5" />`,
        `<path d="M9 15V9.5c0-.28.22-.5.5-.5H15" />`,
    ]
};